import React, { useState, useEffect, useRef,useContext } from "react";
import moment from "moment";
import {Decimal} from 'decimal.js';
import ReactToPrint from "react-to-print-advanced";
import { Container, Label, Row, Col, NavLink  } from "reactstrap";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import CloseIcon from '@mui/icons-material/Close';
import { CLOSE_IMAGE } from "../Componentes/Image";
import { NavLink as RRNavLink} from "react-router-dom";
import StoreContext from "./../Componentes/Store/Context";
import {MDBIcon, MDBTabs,MDBTabsLink,MDBTabsContent,MDBTabsPane,MDBTable, MDBTableHead, MDBTableBody} from "mdb-react-ui-kit";
import {DATATABLE_TRAZABILIDAD,DATATABLE_DC_COMPRA,DATATABLE_INV_INVENTARIO, DATATABLE_MOVIMIENTO_INVENTARIO, DATATABLE_ENTRADA_INVENTARIO, DATATABLE_SALIDA_VENTA, DATATABLE_ENTRADA_FACTURA_COMPRA} from "../Componentes/Datatables"
import { FacturaCompraModal,DeleteModal,RecuentoModal, MovimientoModal } from "../Componentes/Modal";
import { IconButton } from "@mui/material";
import {get_inventario,put_dc_compra_sts,get_pro_proveedor,get_articulo_by_code,post_dc_compra,get_compra_detalle,delete_dc_compra_detalle,put_dcd_compra_detalle_row,
  put_dcd_compra_encabezado,processInventario,get_list_items,get_recuento_detalle,get_recuento,post_re_recuento,procesar_recuento,delete_red_recuento_detalle,
  put_re_recuento_sts,put_red_recuento_detalle_row,put_re_recuento_encabezado, get_trazabilidad,get_trazabilidad_detallado,get_movimiento_detalle,delete_movimiento_detalle,
  get_movimiento,put_mov_movimiento_encabezado,post_mov_movimiento,get_bod_bodega,put_movd_movimiento_detalle, procesar_movimiento,get_list_items_bodega,
  put_mov_movimiento_sts} from "../Componentes/Services";
  import { ComponentToPrintss,ComponentToPrintsRecuento, ComponentToPrintsReporteMovimientos } from "./ComponentToPrintss";
import {BODY_DC_COMPRA, DC_UPDATE_CANTIDAD,BODY_RE_RECUENTO, RE_UPDATE_CANTIDAD, MOV_UPDATE_CANTIDAD, BODY_MOV_MOVIMIENTO} from "./../Componentes/Util";
import {STATES_COM_COMPANIA, STATES_DC_COMPRA,STATES_MOV_MOVIMIENTO,STATES_RE_RECUENTO} from "./../Componentes/States";

export const Inventario = () => {
  var componentRef = useRef();
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalProcesar, setBasicModalProcesar] = useState(false);
  const [dataItems, setDataItems] = useState([]);
  const [dataItemsBodega, setDataItemsBodega] = useState([]);
  const [tabsActive, setTabsActive] = useState("tab1");
  const [tabsActiveH, setTabsActiveH] = useState("tab1");
  const [isPrinting, setPrintI] = useState(false);
  const [isLoadingFC, setLoadingFC] = useState(false);
  const [isSaveI, setSaveI] = useState(false);
  const [dataProveedor, setDataProveedor] = useState([]);
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [error, setError] = useState("");
  const [error_upc, setError_upc] = useState("");
  const [dataCompra, setDataCompra] = useState([]);
  const [dataCompraDetalle, setOBJCompraDetalle] = useState([]);
  const { dataCompania,usr_sucursal,usr_a_costo,usr_id,usr_fac_compra,usr_movimiento,usr_hacer_inventario,usr_trazabilidad } = useContext(StoreContext);
  const [formDropDownProveedor, setFormDropDownProveedor] = useState({prov_id: "",prov_nombre: "",bod_id:"",bod_nombre:""});
  const [dataCompania_f, setdataCompania_f] = useState(STATES_COM_COMPANIA({stateName:"formCompania"}));
  const [formCompraDelete, setFormCompraDelete] = useState({dc_id:"",dc_status:""});
  const [formProcess, setFormProcess] = useState({dcd_identificador:"",dc_proveedor:"",dc_id:"",bod_id:""});
  const [formCompra, setFormCompra] = useState(STATES_DC_COMPRA({staneName:"formCompra"}));
  const [formCompraDetalle, setFormCompraDetalle] = useState(STATES_DC_COMPRA({staneName:"formCompraDetalle"}));
  const [dataBodegas, setDataBodegas] = useState([]);

  const onClickUpdateCompra_sts = () => {
    var body = {
      dc_id: formCompraDelete.dc_id,
      dc_status: formCompraDelete.dc_status,
    };
    put_dc_compra_sts(body);
    setTimeout(() => {
      fetchDCCompra();
      setBasicModalDelete(false)
    }, 1000);
  };

  const handleTabClick = (value) => {
    if (value === tabsActive) {
      return;
    }
    setTabsActive(value);
    setPrintI(false)
  };
  async function fetchBodega() {
    var response;
    response = await get_bod_bodega(usr_sucursal);
    setDataBodegas(response);
  }
  async function fetchDCCompraDetalle(dc_identificador) {
    setLoadingFC(true);
    var response;
    response = await get_compra_detalle(dc_identificador);
    setOBJCompraDetalle(response);
    setLoadingFC(false);
  }
  async function fetch_list_items_bodega() {
    var response;
    response = await get_list_items_bodega();
    setDataItemsBodega(response);
  } 

  async function fetch_list_items() {
    var response;
    response = await get_list_items(usr_sucursal);
    setDataItems(response);
  } 

  async function fetchDCCompra() {
    setLoadingFC(true);
    var response;
    response = await get_inventario(usr_sucursal);
    setDataCompra(response);
    setBasicModal(false);
    setLoadingFC(false);
    setError("");
    setError_upc("");
  }

  async function fetchProveedor() {
    var response;
    response = await get_pro_proveedor();
    setDataProveedor(response);
  }

  async function fetchArticuloByUpc(art_upc) {
    var response;
    response = await get_articulo_by_code(art_upc,usr_sucursal);
    if (response[0] !== undefined) {
      setError_upc("");
      setFormCompraDetalle({
        ...formCompraDetalle,
        dcd_articulo: response[0].art_id,
        dcd_precio: response[0].art_costo,
        art_descripcion: response[0].art_descripcion,
        dcd_itbms: response[0].art_itbm_compra,
        art_upc:response[0].art_upc,
        art_itbm_cod_c:response[0].art_itbm_cod_c,
        art_itbm_compra:response[0].art_itbm_compra,
        dcd_cantidad:"1",
      });
    } else {
      setError_upc("Articulo no existe");
    }
  }
  async function fetchCompania() {
    setdataCompania_f({
      bod_suc: dataCompania.bod_suc,
      com_nombre: dataCompania.com_nombre,
      com_ruc: dataCompania.com_ruc,
      com_dv: dataCompania.com_dv,
      com_direccion: dataCompania.com_direccion,
      com_telefono: dataCompania.com_telefono,
      com_telefono2: dataCompania.com_telefono2,
      com_email: dataCompania.com_email,
      com_fax: dataCompania.com_fax,
      com_web: dataCompania.com_web,
      com_info_interes:dataCompania.com_info_interes,
      com_cotizacion_info:dataCompania.com_cotizacion_info
    });
  }
  useEffect(() => {
    if(tabsActive==="tab1"){
    fetchBodega();
    fetchDCCompra();
    fetchProveedor();
    fetch_list_items()
    fetch_list_items_bodega()
    fetchCompania();
    }

  }, []);

  const onClickSaveCompra = () => {
    setLoadingFC(true)
    if (formCompra.dc_docn.length > 0 && formDropDownProveedor.prov_id.length > 0 && formDropDownProveedor.bod_id.length > 0 && dataCompraDetalle[0] !== undefined) {
      var body =  BODY_DC_COMPRA({dataCompraDetalle,formCompra,formDropDownProveedor,usr_sucursal,usr_id })
      post_dc_compra(body);
      setSaveI(true);
      setTimeout(() => {
        setSaveI(false);
        fetchDCCompra();
        setLoadingFC(false)
      }, 2000);
    } else {
      setError("Campos vacios");
    }
  };

  function onChange(event) {
    const { value, name } = event.target;
    setFormCompra({
      ...formCompra,
      [name]: value,
    });
    setError("");
  }

  function onChangeDC_detail(event) {
    const { value, name } = event.target;
    setFormCompraDetalle({
      ...formCompraDetalle,
      [name]: value,
    });

    if (event.key === "Enter" && name === "art_upc") {
      fetchArticuloByUpc(value);
    }

    setError("");
    setError_upc("");
  }

  function handleKeyPress(event,dcd_cantidad,targ) {
    const { value, name } = event.target;
    if (event.key === "Enter" && name === "art_upc") {
      fetchArticuloByUpc(value);
    }

    if (event.key === "Enter" &&  name === "dcd_cantidad" || targ === "btn") {
      if(basicModalEdit){
        DC_UPDATE_CANTIDAD({dataCompraDetalle,formCompraDetalle,formCompra})
        setTimeout(() => {
          fetchDCCompraDetalle(formCompra.dc_identificador)
        }, 2000);
      }
      else{
        var flag = false;
        var itbms=0;
        var cantidad =0;
        var objItems = dataCompraDetalle.map((data, i) => {
          if (data.dcd_articulo === formCompraDetalle.dcd_articulo &&  data.art_descripcion === formCompraDetalle.art_descripcion && data.art_serie === formCompraDetalle.art_serie) {
            cantidad = Number(data.dcd_cantidad) + Number(formCompraDetalle.dcd_cantidad);
            itbms = (new Decimal(cantidad).times(new Decimal(data.dcd_precio))).times(new Decimal(data.art_itbm_compra));
            flag = true;
            data.dcd_cantidad = Number(cantidad).toFixed(2);
            data.dcd_itbms = itbms;
            data.dcd_total = (new Decimal(cantidad).times(new Decimal(formCompraDetalle.dcd_precio))).plus(new Decimal(itbms));
          }
          return data;
        });
        if (!flag) {
           itbms = (new Decimal(formCompraDetalle.dcd_cantidad).times(new Decimal(formCompraDetalle.dcd_precio))).times(new Decimal(formCompraDetalle.art_itbm_compra));
          setOBJCompraDetalle([...dataCompraDetalle, ...[{...formCompraDetalle,
            dcd_itbms:itbms,
            dcd_total:(new Decimal(formCompraDetalle.dcd_cantidad).times(new Decimal(formCompraDetalle.dcd_precio))).plus(new Decimal(itbms)),
          }]]);
  
        } else {
          setOBJCompraDetalle(objItems);
        }
      }
      setFormCompraDetalle(STATES_DC_COMPRA({staneName:"formCompraDetalle"}));
    }
    setError("");
  }

  const onChangeDropdown = (selectedOptions) => {
    if(selectedOptions.objName==="Bodegas"){
      setFormDropDownProveedor({
        ...formDropDownProveedor,
        bod_id: selectedOptions.value,
        bod_nombre: selectedOptions.label,
      });
    }
    else{
      setFormDropDownProveedor({
        ...formDropDownProveedor,
        prov_id: selectedOptions.value,
        prov_nombre: selectedOptions.label,
      });
    }
  };

  var objBodegas =[];
  var ObjProveedor = [];
  dataProveedor.map((item) => {
    ObjProveedor.push({
      value: item.prov_id,
      label: item.prov_nombre + " / " + item.prov_ruc,
      objName: "Proveedor",
    });
    return null;
  });
  dataBodegas.map((item) => {
    objBodegas.push({
      value: item.bod_id,
      label: item.bod_nombre,
      objName: "Bodegas",
      bod_suc:item.bod_suc
    });
    return null;
  });
  const deleteRow = (row) => {
    if(basicModalEdit){
      delete_dc_compra_detalle(row.original)
      setTimeout(() => {
        fetchDCCompraDetalle(row.original.dcd_identificador)
      }, 1000);
    }
    else{
      var value = dataCompraDetalle.filter((data, i) => {
        if (i !== row.index) return data;
        return null
      });
      setOBJCompraDetalle(value);
    }
  };

  const update_dcd_compra_detalle_row = (values,dcd_identificador) => {
    put_dcd_compra_detalle_row(values)
    setTimeout(() => {
      fetchDCCompraDetalle(dcd_identificador)
    }, 1000);
  };

  const toggleSaveEncabezado = () => {
    var body={
      dc_id:formCompra.dc_id,
      dc_docn:formCompra.dc_docn,
      dc_fecha:formCompra.dc_fecha,
      dc_proveedor:formDropDownProveedor.prov_id,	
      dc_bodega:formDropDownProveedor.bod_id,
      dc_descripcion:formCompra.dc_descripcion
    }
    put_dcd_compra_encabezado(body)
    setTimeout(() => {
      setSaveI(false);
      fetchDCCompra();
      get_inventario()
    }, 1000);
  };
  
  const processarInventario = () => {
    var body={
      dcd_identificador:formProcess.dcd_identificador,
      dc_proveedor:formProcess.dc_proveedor,
      dc_fecha_procesado:moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dc_id:formProcess.dc_id,
      bod_id:formProcess.bod_id,
      dc_suc:usr_sucursal
    }
    processInventario(body)
    setTimeout(() => {
      fetchDCCompra();
      setBasicModalProcesar(false)
    }, 1000);
  };

  const onBlurF = (event,row) => {
      var data = dataCompraDetalle.filter((datos,i)=>{
        if(i !== row.index){
          return datos
        }
        return null
      })
      setOBJCompraDetalle(dataCompraDetalle=>[...data,...[{ art_descripcion: row.original.art_descripcion,
          dcd_cantidad: event.target.value,
          dcd_itbms: row.original.dcd_itbms,
          dcd_precio: row.original.dcd_precio,
          dcd_total: row.original.dcd_total,
          dcd_articulo: row.original.dcd_articulo,
        }]
      ])
  };

  return (
    <Container fluid className="font-s12px">
      {basicModalProcesar && (
        <DeleteModal
          props={"Factura de compra N° "+formProcess.dc_id}
          isOpen={basicModalProcesar}
          toggle={setBasicModalProcesar}
          toggleDelete={processarInventario}
          text={"Procesar factura de compra?"}
          error={""}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={"Inventario N° "+formCompraDelete.dc_id}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateCompra_sts}
          text={"Eliminar este registro?"}
          error={""}
        />
      )}
      {basicModal && (
        <FacturaCompraModal
          dataBodegas={objBodegas}
          props={formCompra}
          dataCompraDetalle={dataCompraDetalle}
          propsDCDetail={formCompraDetalle}
          formDropdown={formDropDownProveedor}
          propsDropdown={ObjProveedor}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveCompra}
          onChange={onChange}
          onChangeDC_detail={onChangeDC_detail}
          handleKeyPress={handleKeyPress}
          onChangeDropdown={onChangeDropdown}
          onBlurs={onBlurF}
          error={error}
          error_upc={error_upc}
          isSaveI={isSaveI}
          deleteRow={deleteRow}
          setOBJCompraDetalle={setOBJCompraDetalle}
          fetchDCCompra={fetchDCCompra}
          update_dcd_compra_detalle_row={update_dcd_compra_detalle_row}
          toggleSaveEncabezado={toggleSaveEncabezado}
          dataItems={dataItems}
          selectItem={fetchArticuloByUpc}
          setFormCompraDetalle={setFormCompraDetalle}
          loading={isLoadingFC}
          usr_sucursal={usr_sucursal}
          usr_a_costo={usr_a_costo}
        />
      )}
      <Row className="mb-2" id="div_tab">
        <Col xs={12}>
          <MDBTabs className="d-flex-none custom-navs">
            <Row>
              <Col xs={12} className="col-btn-reportes">
              {
                usr_fac_compra ==="1" && <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleTabClick("tab1")} active={tabsActive === "tab1"}>
              <MDBIcon fas icon="money-bill" className="me-2"/> Factura de compra
            </MDBTabsLink>
              }
            {usr_trazabilidad ==="1" &&<MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleTabClick("tab2")} active={tabsActive === "tab2"}>
              <MDBIcon fas icon="cash-register" className="me-2"/> Trazabilidad de Artículo
            </MDBTabsLink>}
            {usr_hacer_inventario ==="1" &&<MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleTabClick("tab3")} active={tabsActive === "tab3"}>
              <MDBIcon fas icon="truck-moving" className="me-2"/> Inventario
            </MDBTabsLink>}
            {usr_movimiento ==="1" && <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleTabClick("tab4")} active={tabsActive === "tab4"}>
              <MDBIcon fas icon="cart-flatbed" className="me-2"/> Movimientos
            </MDBTabsLink>}

            <NavLink className="btn-reporte_x_icon tabs-btns font-w-bold menu-l-c-x" tag={RRNavLink} to="/user/home">
              <img src={CLOSE_IMAGE} className="src-image-x" alt="..."/>
            </NavLink>
              </Col>
            </Row>

          </MDBTabs>
        </Col>
      </Row>
     

        <MDBTabsContent>
          <MDBTabsPane show={tabsActive === "tab1"}>
         {
                usr_fac_compra ==="1" &&  <FacturasCompra/>}
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab2"}>
            <Trazabilidad/>
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab3"}>
          <Inventario/>
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab4"}>
          <Movimiento/>
          </MDBTabsPane>
        </MDBTabsContent>
      {/* </Row> */}
    </Container>
  );
  function FacturasCompra(){
    return <>
      {isPrinting ? (
        <React.Fragment>
          <Row>
            <Col xs={10}></Col>
            <Col xs={2}>
              <IconButton className="float-right-btn"
                onClick={() => {
                  setPrintI(false);
                  setFormCompra(STATES_DC_COMPRA({staneName:"formCompra"}));
                  setOBJCompraDetalle([]);
                }}>
                <CloseIcon />
              </IconButton>
              <ReactToPrint
                trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                content={() => componentRef} />
            </Col>
            <Col xs={12} className="text-center scrol-table2">
              <ComponentToPrintss
              ref={el => (componentRef = el)}
              props={dataCompraDetalle}
              formCompra={formCompra}
              formCompania={dataCompania_f} />
            </Col>
          </Row>
          </React.Fragment>
        ) : (
          <Row>
            <Col className="modal-add-inventario datatable-factura css_datatable1" xs={12}>
            <DATATABLE_DC_COMPRA
            dataCompra ={dataCompra} setFormCompraDelete={setFormCompraDelete} setBasicModalDelete={setBasicModalDelete}
            setBasicModalEdit={setBasicModalEdit} setBasicModal={setBasicModal} setFormCompra={setFormCompra} 
            fetchDCCompraDetalle={fetchDCCompraDetalle} setFormDropDownProveedor={setFormDropDownProveedor} setPrintI={setPrintI} setFormProcess={setFormProcess}
            setBasicModalProcesar={setBasicModalProcesar} fetchDCCompra ={fetchDCCompra}setFormCompraDetalle={setFormCompraDetalle} setOBJCompraDetalle={setOBJCompraDetalle}
            isLoadingFC ={isLoadingFC}/> 
            </Col>
          </Row>
        )}
    </>
  }
  function Inventario(){
    const [dataRecuento, setDataRecuento] = useState([]);
    const [error, setError] = useState("");
    const [isLoadingI, setLoadingI] = useState(false);
    const [formRecuento, setFormRecuento] = useState(STATES_RE_RECUENTO({staneName:"formRecuento"}));
    const [isPrinting, setPrintI] = useState(false);
    const [dataRecuentoDetalle, setOBJRecuentoDetalle] = useState([]);
    const [basicModalDeleteRe, setBasicModalDeleteRe] = useState(false);
    const [basicModalProcesarRe, setBasicModalProcesarRe] = useState(false);
    const [formRecuentoDelete, setFormRecuentoDelete] = useState({re_id:"",re_status:""});
    const [formProcessRe, setFormProcessRe] = useState({red_identificador:"",re_id:"",bod_id:"",bod_nombre:"",re_sucursal:""});
    const [basicModalRe, setBasicModalRe] = useState(false);
    const [basicModalEditRe, setBasicModalEditRe] = useState(false);
    const [formRecuentoDetalle, setFormRecuentoDetalle] = useState(STATES_RE_RECUENTO({staneName:"formRecuentoDetalle"}));
    const [error_upc, setError_upc] = useState("");
    const [formDropDownInv, setFormDropDownInv] = useState({bod_id:"",bod_nombre:""});
    const deleteRowRe = (row) => {
      if(basicModalEditRe){
        delete_red_recuento_detalle(row.original)
        setTimeout(() => {
          fetchRecuentoDetalle({re_identificador:row.original.red_identificador});
        }, 1000);
      }
      else{
        var value = dataRecuentoDetalle.filter((data, i) => {
          if (i !== row.index) return data;
          return null;
        });
        setOBJRecuentoDetalle(value);
      }
    };

    async function fetchRecuentoDetalle({re_identificador}) {
      setLoadingI(true);
      var response;
      response = await get_recuento_detalle(re_identificador,usr_sucursal);
      setOBJRecuentoDetalle(response);
      setLoadingI(false);
     
//       if(!basicModalEditRe){
//  setPrintI(true);
//       }
    }

    function onChangeRe(event) {
      const { value, name } = event.target;
      setFormRecuento({
        ...formRecuento,
        [name]: value,
      });
      setError("");
    }

      function onChangeRed_detail(event) {
        const { value, name } = event.target;
        setFormRecuentoDetalle({
          ...formRecuentoDetalle,
          [name]: value,
        });

        if (event.key === "Enter" && name === "art_upc") {
          fetchArticuloByUpc(value);
        }

        setError("");
        setError_upc("");
      }

      const onClickSaveRecuento = () => {
        setLoadingI(true)
        if (dataRecuentoDetalle[0] !== undefined) {

        var body =  BODY_RE_RECUENTO({dataRecuentoDetalle,formRecuento,usr_sucursal,formDropDownInv,usr_id})

        post_re_recuento(body);
            setTimeout(() => {
              setBasicModalRe(false);
              fetchRecuento();
              setLoadingI(false)
            }, 2000);
          } else {
            setError("Campos vacios");
          }
      };

      async function fetchArticuloByUpcRe(art_upc) {
        var response;
        response = await get_articulo_by_code(art_upc,usr_sucursal);
        if (response[0] !== undefined) {
          setError_upc("");
          setFormRecuentoDetalle({
            ...formRecuentoDetalle,
            red_articulo:response[0].art_id,
            red_cantidad: "1",
            art_upc: response[0].art_upc,
            art_descripcion: response[0].art_descripcion,
          });
        } else {
          setError_upc("Articulo no existe");
        }
      }

      function handleKeyPressRe(event,dcd_cantidad,targ ) {
        const { value, name } = event.target;
        if (event.key === "Enter" && name === "art_upc") {
          fetchArticuloByUpcRe(value);
        }

        if (event.key === "Enter" && name === "red_cantidad" || targ === "btn") {
          if(basicModalEditRe){
            RE_UPDATE_CANTIDAD({dataRecuentoDetalle,formRecuentoDetalle,formRecuento})
            setTimeout(() => {
              fetchRecuentoDetalle({re_identificador:formRecuento.re_identificador});
            }, 2000);
          }
          else{
            var flag = false;
            var cantidad =0;
            var objItems = dataRecuentoDetalle.map((data, i) => {
              if (data.red_articulo === formRecuentoDetalle.red_articulo && data.art_serie === formRecuentoDetalle.art_serie) {
                cantidad = Number(data.red_cantidad) + Number(formRecuentoDetalle.red_cantidad);
                flag = true;
                data.red_cantidad = Number(cantidad);
              }
              return data;
            });
            if (!flag) {
              setOBJRecuentoDetalle([...dataRecuentoDetalle, ...[{...formRecuentoDetalle}]]);
            } else {
              setOBJRecuentoDetalle(objItems);
            }
          }
          setFormRecuentoDetalle(STATES_RE_RECUENTO({staneName:"formRecuentoDetalle"}));
        }
        setError("");
        setLoadingI(false)
      }

    async function fetchRecuento() {
      setLoadingI(true);
      var response;
      response = await get_recuento(usr_sucursal);
      setDataRecuento(response);
      setError("");
    }
  
    useEffect(() => {
     
      if(tabsActive === "tab3"){
         fetchRecuento();
      }
    }, []);

    const update_red_recuento_detalle_row_re = (values,red_identificador) => {
      put_red_recuento_detalle_row(values)
      setTimeout(() => {
        fetchRecuentoDetalle({re_identificador:red_identificador})
        
      }, 1000);
    };

    const onClickUpdateRecuento_sts = () => {
      var body = {
        re_id: formRecuentoDelete.re_id,
        re_status: "0",
      };
      put_re_recuento_sts(body);
      setTimeout(() => {
        fetchRecuento();
        setBasicModalDeleteRe(false)
      }, 1000);
    };

    const toggleSaveEncabezadoRe = () => {
      var body={
        re_id:formRecuento.re_id,
        re_descripcion:formRecuento.re_descripcion,
        re_bodega:formDropDownInv.bod_id
      }
      put_re_recuento_encabezado(body);
      setTimeout(() => {
        setBasicModalRe(false);
        fetchRecuento();
        fetchRecuentoDetalle({re_identificador:formRecuento.re_identificador})
      }, 1000);
    };
    const processarInventarioRe = () => {
      var body={
        red_identificador:formProcessRe.red_identificador,
        re_id:formProcessRe.re_id,
        re_sucursal:formProcessRe.re_sucursal,
        bod_id:formProcessRe.bod_id,
        re_fecha_procesado:moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      }

      procesar_recuento(body)
      setTimeout(() => {
        fetchRecuento();
        setBasicModalProcesarRe(false)
      }, 1000);
    };
  const onChangeDropdownInv = (selectedOptions) => {
      setFormDropDownInv({
        ...formDropDownInv,
        bod_id: selectedOptions.value,
        bod_nombre: selectedOptions.label,
      });
  };
    return <>
     {basicModalProcesarRe && (
        <DeleteModal
          props={"Inventario N° "+formProcessRe.re_id}
          isOpen={basicModalProcesarRe}
          toggle={setBasicModalProcesarRe}
          toggleDelete={processarInventarioRe}
          text={"Procesar inventario?"}
          error={""}
        />
      )}

     {basicModalDeleteRe && (
        <DeleteModal
          props={"Inventario N° "+formRecuentoDelete.re_id}
          isOpen={basicModalDeleteRe}
          toggle={setBasicModalDeleteRe}
          toggleDelete={onClickUpdateRecuento_sts}
          text={"Eliminar este registro?"}
          error={""}
        />
      )}
    {basicModalRe && (
        <RecuentoModal
          dataBodegas={objBodegas}
         onChangeDropdown={onChangeDropdownInv}
         formDropdown={formDropDownInv}
          props={formRecuento}
          dataRecuentoDetalle={dataRecuentoDetalle}
          formRecuentoDetalle={formRecuentoDetalle}
          isOpen={basicModalRe}
          basicModalEditRe={basicModalEditRe}
          toggle={setBasicModalRe}
          toggleSave={onClickSaveRecuento}
          onChange={onChangeRe}
          onChangeRed_detail={onChangeRed_detail}
          handleKeyPress={handleKeyPressRe}
          onBlurs={onBlurF}
          error={error}
          error_upc={error_upc}
          isSaveI={isSaveI}
          deleteRow={deleteRowRe}
          setOBJRecuentoDetalle={setOBJRecuentoDetalle}
          fetchRecuento={fetchRecuento}
          dataItems={dataItems}
          update_red_recuento_detalle_row_re={update_red_recuento_detalle_row_re}
          toggleSaveEncabezado={toggleSaveEncabezadoRe}
          dataRecuento={dataRecuento}
          selectItem={fetchArticuloByUpcRe}
          setFormRecuentoDetalle={setFormRecuentoDetalle}
          loading={isLoadingI}
          usr_sucursal={usr_sucursal}
          setPrintI={setPrintI}
          usr_a_costo={usr_a_costo}

        />
      )}
            {isPrinting ? (
            <React.Fragment>
            <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintI(false);
                        setFormCompra(STATES_RE_RECUENTO({staneName:"formRecuento"}));
                        setOBJRecuentoDetalle([]);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                  <ComponentToPrintsRecuento
                    ref={el => (componentRef = el)}
                    props={dataRecuentoDetalle}
                    formRecuento={formRecuento}
                    formCompania={dataCompania_f}
                  />
                    </Col>
                </Row>
          </React.Fragment>
        ) : (
          <>
            <Row>
            <Col className="modal-add-inventario datatable-factura css_datatable1">
            <DATATABLE_INV_INVENTARIO dataRecuento={dataRecuento} setFormRecuentoDelete ={setFormRecuentoDelete} setBasicModalDeleteRe  ={setBasicModalDeleteRe}
              fetchRecuentoDetalle  ={fetchRecuentoDetalle}
              setFormRecuento ={setFormRecuento}
              setBasicModalRe ={setBasicModalRe}
              setBasicModalEditRe ={setBasicModalEditRe}
              setPrintI ={setPrintI} 
              setFormProcessRe ={setFormProcessRe} 
              setBasicModalProcesarRe ={setBasicModalProcesarRe}
              setOBJRecuentoDetalle ={setOBJRecuentoDetalle}
              fetchRecuento ={fetchRecuento}
              setFormRecuentoDetalle ={setFormRecuentoDetalle}
              setFormDropDownInv={setFormDropDownInv}/>
            </Col>
            </Row>

          </>

        )}

    </>
  }
  function Movimiento(){
    const [dataMovimiento, setDataMovimiento] = useState([]);
    const [error, setError] = useState("");
    const [isLoadingM, setLoadingM] = useState(false);
    const [formMovimiento, setFormMovimiento] = useState(STATES_MOV_MOVIMIENTO({staneName:"formMovimiento"}));
    const [isPrintingM, setPrintM] = useState(false);
    const [dataMovimientoDetalle, setOBJMovimientoDetalle] = useState([]);
    const [basicModalDeleteMov, setBasicModalDeleteMov] = useState(false);
    const [basicModalProcesarMov, setBasicModalProcesarMov] = useState(false);
    const [formMovimientoDelete, setFormMovimientoDelete] = useState({mov_id:"",mov_sts:""});
    const [formProcessMov, setFormProcessMov] = useState({mov_identificador:"",mov_id:""});
    const [basicModalMov, setBasicModalMov] = useState(false);
    const [basicModalEditMov, setBasicModalEditMov] = useState(false);
    const [formMovimientoDetalle, setFormMovimientoDetalle] = useState(STATES_MOV_MOVIMIENTO({staneName:"formMovimientoDetalle"}));
    const [error_upc, setError_upc] = useState("");

    const deleteRowRe = (row) => {
      var body={
          ...row.original,movd_sts:"0"
      }
      if(basicModalEditMov){
        delete_movimiento_detalle(body)
        setTimeout(() => {
          fetchMovimientoDetalle({mov_identificador:row.original.movd_identificador});
        }, 1000);
      }
      else{
        var value = dataMovimientoDetalle.filter((data, i) => {
          if (i !== row.index) return data;
          return null;
        });
        setOBJMovimientoDetalle(value);
      }
    };

    async function fetchMovimientoDetalle({mov_identificador}) {
      setLoadingM(true);
      var response;
      response = await get_movimiento_detalle(mov_identificador);
      setFormMovimiento({
              mov_id:response.mov_movimiento[0].mov_id,
              mov_identificador:response.mov_movimiento[0].mov_identificador, 	
              mov_fecha:response.mov_movimiento[0].mov_fecha, 	
              mov_fecha_procesado:response.mov_movimiento[0].mov_fecha_procesado, 	
              mov_descripcion:response.mov_movimiento[0].mov_descripcion, 	
              mov_bodega_desde:response.mov_movimiento[0].mov_bodega_desde, 	
              mov_bodega_hacia:response.mov_movimiento[0].mov_bodega_hacia, 	
              mov_bodega_desde_nombre:response.mov_movimiento[0].bod_desde, 	
              mov_bodega_hacia_nombre:response.mov_movimiento[0].bod_hacia, 	
              mov_unique:response.mov_movimiento[0].mov_unique, 	
              mov_procesado:response.mov_movimiento[0].mov_procesado, 	
              mov_sts:response.mov_movimiento[0].mov_sts,
              inv_qty:"0",
              // art_serie:response.mov
            } );
      setOBJMovimientoDetalle(response.movd_movimiento_detail);
      setLoadingM(false);
    }

    function onChangeMov(event) {
      const { value, name } = event.target;
      setFormMovimiento({
        ...formMovimiento,
        [name]: value,
      });
      setError("");
    }

      function onChangeRed_detail(event) {
        const { value, name } = event.target;
        setError("");
        setError_upc("");
        if(name ==="movd_cantidad"){
          if(value<=Number(formMovimientoDetalle.inv_qty)){
            setFormMovimientoDetalle({
              ...formMovimientoDetalle,
              [name]: value,
              inv_qty:formMovimientoDetalle.inv_qty
            });
          }
          else{
            setError_upc("Cantidad debe ser menor o igual a la existencia en bodega.")
          }
        }
        else{
          setFormMovimientoDetalle({
            ...formMovimientoDetalle,
            [name]: value,
              inv_qty:formMovimientoDetalle.inv_qty
          });
        }

        if (event.key === "Enter" && name === "art_upc") {
          fetchArticuloByUpc(value);
        }

       
      }
      const onClickSaveMovimiento = () => {
        setLoadingM(true)
        if (dataMovimientoDetalle[0] !== undefined) {
          var body =  BODY_MOV_MOVIMIENTO({dataMovimientoDetalle,formMovimiento})
          post_mov_movimiento(body);
          setTimeout(() => {
            setBasicModalMov(false);
            fetchMovimiento();
            setLoadingM(false)
          }, 2000);
        } else {
          setError("Campos vacios");
        }
      };

      async function fetchArticuloByUpcMov({art_upc,inv_qty}) {
        var response;
        response = await get_articulo_by_code(art_upc,usr_sucursal);
        if (response[0] !== undefined) {
          setError_upc("");
          setFormMovimientoDetalle({
            ...formMovimientoDetalle,
            movd_articulo:response[0].art_id,
            movd_cantidad: "1",
            art_upc: response[0].art_upc,
            art_descripcion: response[0].art_descripcion,
            inv_qty:inv_qty
          });
        } else {
          setError_upc("Articulo no existe");
        }
      }

      function handleKeyPressMov(event,dcd_cantidad,targ) {
        const { value, name } = event.target;  
        if (event.key === "Enter" && name === "art_upc") {
          fetchArticuloByUpcMov(value);
        }

        if (event.key === "Enter" && name === "movd_cantidad" || targ === "btn") {
          if(basicModalEditMov){
            MOV_UPDATE_CANTIDAD({dataMovimientoDetalle,formMovimientoDetalle,formMovimiento})
            setTimeout(() => {
              fetchMovimientoDetalle({mov_identificador:formMovimiento.mov_identificador});
            }, 2000);
          }
          else{
            var flag = false;
            var cantidad =0;
            var objItems = dataMovimientoDetalle.map((data, i) => {
              if (data.movd_articulo === formMovimientoDetalle.movd_articulo  && data.art_serie === formMovimientoDetalle.art_serie) {
                cantidad = Number(data.movd_cantidad) + Number(formMovimientoDetalle.movd_cantidad);
                flag = true;
                data.movd_cantidad = Number(cantidad);
              }
              return data;
            });
            if (!flag) {
              setOBJMovimientoDetalle([...dataMovimientoDetalle, ...[{...formMovimientoDetalle}]]);
            } else {
              setOBJMovimientoDetalle(objItems);
            }
          }
          setFormMovimientoDetalle(STATES_MOV_MOVIMIENTO({staneName:"formMovimientoDetalle"}));
        }
        setError("");
        setLoadingM(false)
      }

    async function fetchMovimiento() {
      setLoadingM(true);
      var response;
      response = await get_movimiento();
      setDataMovimiento(response);
      setError("");
    }
  
    useEffect(() => {
     
      if(tabsActive === "tab4"){
         fetchMovimiento();
      }
    }, []);

    const update_mov_movimiento_detalle_row = (values,movd_identificador) => {
      put_movd_movimiento_detalle(values)
      setTimeout(() => {
        fetchMovimientoDetalle({mov_identificador:values.movd_identificador})
      }, 1000);
    };

    const onClickDeleteMovimiento_sts = () => {
      var body = {
        mov_id: formMovimientoDelete.mov_id,
        mov_sts: "0",
      };
      put_mov_movimiento_sts(body);
      setTimeout(() => {
        fetchMovimiento();
        setBasicModalDeleteMov(false)
      }, 1000);
    };
  const onChangeDropdown = (selectedOptions) => {
    setError("");
    if(selectedOptions.objName==="bodegaDesde"){
     
     setFormMovimiento({...formMovimiento,mov_bodega_desde:selectedOptions.value,mov_bodega_desde_nombre:selectedOptions.label})
     setFormMovimientoDetalle({movd_id: "",
      movd_articulo: "",
      movd_cantidad: "1",
      movd_identificador: "",
      art_upc: "",
      art_descripcion: "",})
    }
    else{
     setFormMovimiento({...formMovimiento,mov_bodega_hacia:selectedOptions.value,mov_bodega_hacia_nombre:selectedOptions.label})
    }
   
  }
    const toggleSaveEncabezadoMov = () => {
      var body={
        mov_id:formMovimiento.mov_id,
        mov_fecha:formMovimiento.mov_fecha,
        mov_descripcion:formMovimiento.mov_descripcion,
        mov_bodega_desde:formMovimiento.mov_bodega_desde,
        mov_bodega_hacia:formMovimiento.mov_bodega_hacia
      }
      put_mov_movimiento_encabezado(body);
      setTimeout(() => {
        
        fetchMovimientoDetalle({mov_identificador:formMovimiento.mov_identificador})
      }, 1000);
    };
    const processarInventarioMov = async () => {
      var response;
      response = await get_movimiento_detalle(formProcessMov.mov_identificador);
      var body = {
        mov_identificador:formProcessMov.mov_identificador,
        mov_id:formProcessMov.mov_id,
        mov_fecha_procesado:moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        mov_movimiento:response.mov_movimiento,
        movd_movimiento_detail:response.movd_movimiento_detail,
        MovUpdate:response.MovUpdate
      }
      procesar_movimiento(body)
      setTimeout(() => {
        fetchMovimiento();
        setBasicModalProcesarMov(false)
      }, 1000);
    };
    return <>
      {basicModalDeleteMov && (
        <DeleteModal
          props={"Movimiento N° "+formMovimientoDelete.mov_id}
          isOpen={basicModalDeleteMov}
          toggle={setBasicModalDeleteMov}
          toggleDelete={onClickDeleteMovimiento_sts}
          text={"Eliminar movimiento?"}
          error={""}
        />
      )}
      {basicModalProcesarMov && (
        <DeleteModal
          props={"Movimiento N° "+formProcessMov.mov_id}
          isOpen={basicModalProcesarMov}
          toggle={setBasicModalProcesarMov}
          toggleDelete={processarInventarioMov}
          text={"Procesar movimiento?"}
          error={""}
        />
      )}
    {basicModalMov && (
      <MovimientoModal
        props={formMovimiento}
        setFormMovimiento={setFormMovimiento}
        dataMovimientoDetalle={dataMovimientoDetalle}
        formMovimientoDetalle={formMovimientoDetalle}
        isOpen={basicModalMov}
        basicModalEditMov={basicModalEditMov}
        toggle={setBasicModalMov}
        toggleSave={onClickSaveMovimiento}
        onChange={onChangeMov}
        onChangeRed_detail={onChangeRed_detail}
        handleKeyPress={handleKeyPressMov}
        onBlurs={onBlurF}
        error={error}
        error_upc={error_upc}
        isSaveI={isSaveI}
        deleteRow={deleteRowRe}
        setOBJMovimientoDetalle={setOBJMovimientoDetalle}
        fetchMovimiento={fetchMovimiento}
        dataItems={dataItemsBodega}
        update_mov_movimiento_detalle_row={update_mov_movimiento_detalle_row}
        toggleSaveEncabezado={toggleSaveEncabezadoMov}
        dataRecuento={dataMovimiento}
        selectItem={fetchArticuloByUpcMov}
        setFormMovimientoDetalle={setFormMovimientoDetalle}
        loading={isLoadingM}
        dataBodegas={dataBodegas}
        onChangeDropdown={onChangeDropdown}
        usr_a_costo={usr_a_costo}
      />)}
            {isPrintingM ? (
            <React.Fragment>
            <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintI(false);
                        setFormCompra(STATES_RE_RECUENTO({staneName:"formRecuento"}));
                        setOBJMovimientoDetalle([]);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                  <ComponentToPrintsReporteMovimientos
                    ref={el => (componentRef = el)}
                    props={dataMovimientoDetalle}
                    formMovimiento={formMovimiento}
                    formCompania={dataCompania_f}
                  />
                    </Col>
                </Row>
          </React.Fragment>
        ) : (
          <>
            <Row>
            <Col className="modal-add-inventario datatable-factura  css_datatable1">
            <DATATABLE_MOVIMIENTO_INVENTARIO dataMovimiento={dataMovimiento}
              setFormMovimientoDelete ={setFormMovimientoDelete} 
              setBasicModalDeleteMov  ={setBasicModalDeleteMov}
              fetchMovimientoDetalle  ={fetchMovimientoDetalle}
              setFormMov ={setFormMovimiento}
              setBasicModalMov ={setBasicModalMov}
              setBasicModalEditMov ={setBasicModalEditMov}
              setPrintM ={setPrintM} 
              setFormProcessMov ={setFormProcessMov} 
              setBasicModalProcesarMov ={setBasicModalProcesarMov}
              setOBJMovimientoDetalle ={setOBJMovimientoDetalle}
              fetchMovimiento ={fetchMovimiento}
              setFormMovimientoDetalle ={setFormMovimientoDetalle}
              />
            </Col>
            </Row>

          </>

        )}

    </>
  }
  function Trazabilidad(){
    const [dataTrazabilidad, setdataTrazabilidad] = useState([]);
    const [isOpenTabTrazabilidadDetail, setTabTrazabilidadDetail] = useState(false);
    const [dataTrazabilidadVentas, setOBJTrazabilidadVentas] = useState([]);
    const [dataTrazabilidadCompra, setOBJTrazabilidadCompra] = useState([]);
    const [dataTrazabilidadRecuento, setOBJTrazabilidadRecuento] = useState([]);
    const [tabsActiveH, setTabsActiveH] = useState("tab1");
    const [formArticulo, setFormArticulo] = useState({
      art_id:"",
      art_upc:"",
      art_descripcion:"",
    });

    const handleTabClickH = (value) => {
    if (value === tabsActiveH) {
      return;
    }
    setTabTrazabilidadDetail(true);
    setTabsActiveH(value);
    document.getElementById("div_tab").style.display = "none"; // Ocultar el div
  };
    async function fetchMovimiento() {
      var response;
      response = await get_trazabilidad(usr_sucursal);
      setdataTrazabilidad(response);
    }

    async function fetchTrazabilidadDetallado({art_id,art_upc,art_descripcion}) {
      document.getElementById("div_tab").style.display = "none"; // Ocultar el div
      setFormArticulo({
      art_id:art_id,
      art_upc:art_upc,
      art_descripcion:art_descripcion
      });
      var response;
      response = await get_trazabilidad_detallado(art_id,usr_sucursal);
      setOBJTrazabilidadVentas(response.ventas);
      setOBJTrazabilidadCompra(response.dc_compra);
      setOBJTrazabilidadRecuento(response.re_recuento);

    }
    useEffect(() => {
      if(tabsActive === "tab2"){
        fetchMovimiento();
      }
    }, []);

    return <>
            {isOpenTabTrazabilidadDetail ? (
            <React.Fragment>
            <Row className="mb-2">
              <Col xs={12}>
                <MDBTabs className="d-flex-none custom-navs">
                  <Row>
                    <Col xs={12} className="col-btn-reportes">
                  <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleTabClickH("tab1")} active={tabsActiveH === "tab1"}>
                    <MDBIcon fas icon="money-bill" className="me-2"/> SALIDA POR VENTA
                  </MDBTabsLink>
                  <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleTabClickH("tab2")} active={tabsActiveH === "tab2"}>
                    <MDBIcon fas icon="cash-register" className="me-2"/> ENTRADA POR FACTURA DE COMPRA 
                  </MDBTabsLink>
                  <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleTabClickH("tab3")} active={tabsActiveH === "tab3"}>
                    <MDBIcon fas icon="truck-moving" className="me-2"/> ENTRADA POR INVENTARIO
                  </MDBTabsLink>
                  <NavLink className="btn-reporte_x_icon tabs-btns font-w-bold menu-l-c-x">
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setTabTrazabilidadDetail(false);
                        setOBJTrazabilidadVentas([]);
                        document.getElementById("div_tab").style.display = "block";
                      }}>
                      <CloseIcon />
                    </IconButton>
                  </NavLink>
                    </Col>
                  </Row>
                </MDBTabs>
              </Col>
            </Row>
            <MDBTabsContent>
              <MDBTabsPane show={tabsActiveH === "tab1"}>
                <Row>
                  <Col xs={12}>
                    <Label className="font-form-articulo">CÓDIGO:  {formArticulo.art_upc+"  "}</Label>
                    <Label className="font-form-articulo"> &nbsp;{formArticulo.art_descripcion}</Label>
                  </Col>
                  <Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
                   <DATATABLE_SALIDA_VENTA dataSalidaVenta ={dataTrazabilidadVentas}/>
                  </Col>
                </Row>
              </MDBTabsPane>
              <MDBTabsPane show={tabsActiveH === "tab2"}>
                <Row>
                  <Col xs={12}>
                    <Label className="font-form-articulo">CÓDIGO: {formArticulo.art_upc}</Label>
                    <Label className="font-form-articulo">&nbsp;{formArticulo.art_descripcion}</Label>
                  </Col>
                  <Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
                         <DATATABLE_ENTRADA_FACTURA_COMPRA dataEntradaFCompra ={dataTrazabilidadCompra}/>
                  </Col>
                </Row>              
              </MDBTabsPane>
              <MDBTabsPane show={tabsActiveH === "tab3"}>
                <Row>
                  <Col xs={12}>
                    <Label className="font-form-articulo">CÓDIGO: {formArticulo.art_upc}</Label>
                    <Label className="font-form-articulo">&nbsp;{formArticulo.art_descripcion}</Label>
                  </Col>
                  <Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
                         <DATATABLE_ENTRADA_INVENTARIO dataEntradaInventario ={dataTrazabilidadRecuento}/>
                  </Col>
                </Row>    
              </MDBTabsPane>
            </MDBTabsContent>
          </React.Fragment>
        ) : (
          <>
            <Row>
              <Col className="modal-add-inventario datatable-factura css_datatable1">
                <DATATABLE_TRAZABILIDAD dataTrazabilidad ={dataTrazabilidad} setTabTrazabilidadDetail={setTabTrazabilidadDetail}fetchTrazabilidadDetallado  ={fetchTrazabilidadDetallado}/>
              </Col>
            </Row>
          </>
        )}
    </>
  }
};